import axios from "../../axios";

const API_PATH_FETCH_MASTER = process.env.REACT_APP_API_MASTER_URL + '/fetchMaster';

const getTestMaster = async () => {
  const response = await axios({
    url: API_PATH_FETCH_MASTER + '/getTestMaster',
    method: "GET"
  });
  return response?.data;
};


const masterService = {
  getTestMaster
};

export default masterService;